import React from 'react';
import Column from 'src/components/10-atoms/layout/Column';
import Row from 'src/components/10-atoms/layout/Row';
import Typography from 'src/components/10-atoms/typography/Typography';
import BottomDrawerLayout from 'src/components/20-helper-views/bottom-drawer/BottomDrawerLayout';
import { TypographyFontWeight, TypographyVariant, } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import styleUtils from 'src/utils/styles';
import SelectCommunityPanel from '../panels/SelectCommunityPanel';
import SelectExamLevelPanel from '../panels/SelectExamLevelPanel';
import { EXAM_LEVEL_SELECT_POPOVER_LIST_HEIGHT } from '../types';
import useSelectionFlow from '../useSelectionFlow';
const SelectExamLevelOverlayContent = ({ value, onChange, layout, listHeight = EXAM_LEVEL_SELECT_POPOVER_LIST_HEIGHT, }) => {
    const [{ theme }] = useTheme();
    const { step, draft, title, selectCommunity, goBackToCommunity, selectExamLevel, } = useSelectionFlow(value);
    const panels = step === 'community' ? (React.createElement(SelectCommunityPanel, { value: draft?.community, onChange: selectCommunity, containerStyle: layout === 'popover' ? { height: listHeight } : undefined })) : (draft?.community && (React.createElement(SelectExamLevelPanel, { value: draft, onChange: newValue => selectExamLevel(newValue.examLevel, onChange), onCommunityChange: goBackToCommunity, containerStyle: layout === 'popover' ? { height: listHeight } : undefined, listStyle: layout === 'popover' ? { height: listHeight } : undefined })));
    if (layout === 'drawer') {
        return (React.createElement(BottomDrawerLayout, { yAxis: "flex-start", style: styleUtils.containerHeight },
            React.createElement(BottomDrawerLayout.Title, null, title),
            panels));
    }
    return (React.createElement(Column, { spacing: theme.spacing.standard.xxs, style: { height: listHeight + 56 } },
        React.createElement(Row, { pv: theme.spacing.standard.xs, ph: theme.spacing.page },
            React.createElement(Typography, { variant: TypographyVariant.BODY_TITLE, fontWeight: TypographyFontWeight.MEDIUM }, title)),
        panels));
};
export default SelectExamLevelOverlayContent;
